import * as ajax from './ajax';
import schemaConstants from '../constants/schemaConstants';
import tokenErrorActions from './tokenErrorActionCreators';
const loadSuccess = data => ({
  type: schemaConstants.SCHEMA_LOAD_SUCCESS,
  data
});
const loadFailure = data => ({
  type: schemaConstants.SCHEMA_LOAD_FAIL,
  data
});
const serverLoad = () => async dispatch => {
  try {
    const response = await ajax.get('/schemas');
    return dispatch(loadSuccess(response.data));
  } catch (e) {
    return dispatch(tokenErrorActions.handleError(e, 'schema', loadFailure.bind(this, ajax.getError(e)), serverLoad.bind(this)));
  }
};
const refresh = () => (dispatch, getState) => {
  const {
    schema
  } = getState();
  if (!schema.loaded) {
    return dispatch(serverLoad());
  }
  return Promise.resolve();
};
const actions = {
  serverLoad,
  refresh
};
export default actions;